import styled, { css } from "styled-components";
import { Button } from "reactstrap";
import { ReactComponent as DatevCloudLogo } from "../../_assets/img/datev-cloud-logo.svg";
import { ReactComponent as MicrosoftLogo } from "../../_assets/img/microsoft-logo.svg";
import { ReactComponent as GoogleLogo } from "../../_assets/img/google-logo.svg";

import {
    MdAddCircle,
    MdArrowDownward,
    MdArrowUpward,
    MdAttachFile,
    MdAutoAwesome,
    MdCheckCircle,
    MdCircle,
    MdContentCopy,
    MdDelete,
    MdDownload,
    MdDragIndicator,
    MdEdit,
    MdEditOff,
    MdInfo,
    MdMoreHoriz,
    MdOutlineChatBubbleOutline,
    MdSave,
    MdSettings,
    MdWatchLater,
    MdWarning,
    MdRefresh,
    MdCancel,
    MdNoteAdd
} from "react-icons/md";
import { CgSpinner } from "react-icons/cg";
import { FaShopify, FaStripeS } from "react-icons/fa";

export const PathwayIconWrapperButton = styled(Button)`
    padding: 0;
    margin: 0;
    background: transparent;
    border: none;

    &:hover {
        background: transparent;
        outline: none;
        box-shadow: none;
    }

    &:focus {
        background: transparent;
        outline: none;
        box-shadow: none;
    }

    &:hover > * {
        filter: grayscale(90%);
        background-color: var(--bs-btn-hover-bg);
        border-color: var(--bs-btn-active-border-color);
        border-radius: var(--bs-btn-border-radius);
    }
`;

export const ButtonWrapperDiv = styled.div`
    display: grid;
    grid-template-rows: min-content;
    grid-template-columns: 1fr;
`;

export const DeleteIcon = styled(MdDelete)`
    color: var(--danger);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const UpArrowIcon = styled(MdArrowUpward)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const DownArrowIcon = styled(MdArrowDownward)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const EditOffIcon = styled(MdEditOff)`
    color: var(--danger);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;
export const SaveIcon = styled(MdSave)`
    color: ${(props) => (props.color ? props.color : css`var(--success)`)};
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const EditIcon = styled(MdEdit)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const SettingsIcon = styled(MdSettings)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const AddIcon = styled(MdAddCircle)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const InfoIcon = styled(MdInfo)`
    color: var(--dark);
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-standard)")};
    ${(props) =>
        props.$primary &&
        css`
            color: var(--primary);
        `};
`;

export const WaitingIcon = styled(MdWatchLater)`
    color: var(--warning);
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-xs)")};
    ${(props) =>
        props.$warning &&
        css`
            color: var(--warning);
        `};
`;

export const WarningIcon = styled(MdWarning)`
    color: var(--warning);
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-xs)")};
`;

export const RefreshIcon = styled(MdRefresh)`
    color: var(--info);
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-xs)")};
`;

export const CancelIcon = styled(MdCancel)`
    color: var(--danger);
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-xs)")};
`;

export const NoteAddIcon = styled(MdNoteAdd)`
    color: var(--primary);
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-xs)")};
`;

export const CheckIcon = styled(MdCheckCircle)`
    color: var(--success);
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-xs)")};
`;

export const MoreIcon = styled(MdMoreHoriz)`
    color: #1b8eb7;
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const ShopifyIcon = styled(FaShopify)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const CircleIcon = styled(MdCircle)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const StripeIcon = styled(FaStripeS)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const FileIcon = styled(MdAttachFile)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-xs)")};
`;

export const ChatIcon = styled(MdOutlineChatBubbleOutline)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const DragIndicatorIcon = styled(MdDragIndicator)`
    color: ${(props) => (props.color ? props.color : "#999")};
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const CopyIcon = styled(MdContentCopy)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const CloneIcon = styled(MdDownload)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

// Inherits color from the parent button (currentColor), so it stays white on a dark button.
export const DownloadIcon = styled(MdDownload)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const AiTokenIcon = styled(MdAutoAwesome)`
    color: var(--primary);
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const AttachmentIcon = styled(MdAttachFile)`
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-xs)")};
`;

export const DatevCloudIcon = styled(DatevCloudLogo)`
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-standard)")};
`;

export const MicrosoftIcon = styled(MicrosoftLogo)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const GoogleIcon = styled(GoogleLogo)`
    font-size: ${(props) => (props.size ? props.size : "var(--iconSize-standard)")};
`;

export const SpinnerIcon = styled(CgSpinner)`
    font-size: ${(props) => (props.$size ? props.$size : "var(--iconSize-standard)")};
    animation: icon-spinner 0.75s linear infinite;
    ${(props) =>
        props.$primary &&
        css`
            color: var(--primary);
        `};
    @keyframes icon-spinner {
        to {
            transform: rotate(360deg);
        }
    }
`;
